import {
  CART_CHANGE_FAILURE,
  CART_ERROR,
  CART_IS_LOADING,
  CART_RESET_STATE,
  PIN_IS_VALID,
  RECEIVE_CART_ITEMS,
  RECEIVE_CART_PROMOS,
  RECEIVE_CART_RECOS,
  RECEIVE_PIN,
  RECEIVE_TRACKING_NUMBER,
  REQUEST_CART_UPDATE,
  SHOW_CART_MODAL,
  UPDATE_CART_COUNT
} from 'constants/reduxActions';
import { isMultiMerchant } from 'helpers/CartUtils';
import { AppAction } from 'types/app';
import { AllJanusSlotNames, CartResponse } from 'types/mafia';
import { extractDataFromWidget, JanusRecos } from 'reducers/recos';
import { EmptyObject } from 'types/utility';
import marketplace from 'cfg/marketplace.json';

const { merchantId: marketplaceMerchantId } = marketplace;

export interface CartState {
  isLoaded: boolean;
  cartObj: CartResponse | EmptyObject;
  isMultiMerchantCart: boolean;
  cartCount: number | null;
  error: string | null;
  loading?: boolean;
  isModalShowing?: boolean;
  addedStockId?: string;
  pin?: string;
  trackingNumber?: string;
  isValid?: boolean;
  promos?: any; // TODO ts use correct type when landing page is typed
  janus?: JanusRecos;
  lastReceivedRecoKey?: string;
}

const initialState: CartState = {
  isLoaded: false,
  cartObj: {},
  isMultiMerchantCart: false,
  cartCount: null,
  error: null
};

export default function cart(state: Readonly<CartState> = initialState, action: AppAction): CartState {
  switch (action.type) {
    case RECEIVE_CART_ITEMS:
      const { cartObj, cartCount } = action;
      const isMultiMerchantCart = isMultiMerchant([...cartObj.activeItems, ...cartObj.savedItems], marketplaceMerchantId);
      return {
        ...state,
        cartObj,
        isMultiMerchantCart,
        cartCount,
        isLoaded: true,
        loading: false
      };
    case RECEIVE_CART_PROMOS:
      const { promos } = action;
      return { ...state, promos };
    case RECEIVE_CART_RECOS:
      const { key, data } = action;
      const keys = Object.keys(data) as AllJanusSlotNames[];
      const newCartRecos: JanusRecos = {};
      const reco = data[keys[0]!];
      if (reco) {
        newCartRecos[key] = extractDataFromWidget(reco);
      }

      return { ...state, janus: { ...newCartRecos }, lastReceivedRecoKey: key };
    case UPDATE_CART_COUNT:
      const { cartCount: updatedCartCount } = action;
      return { ...state, cartCount: updatedCartCount };
    case REQUEST_CART_UPDATE:
      return { ...state, loading: true, error: null };
    case CART_CHANGE_FAILURE:
      return { ...state, loading: false };
    case CART_ERROR:
      const { error } = action;
      return { ...state, error };
    case CART_IS_LOADING:
      return { ...state, loading: true };
    case SHOW_CART_MODAL: {
      const { isShowing, stockId } = action;
      return {
        ...state,
        isModalShowing: isShowing,
        addedStockId: isShowing ? stockId : undefined
      };
    }
    case RECEIVE_PIN: {
      const { pin } = action;
      return { ...state, pin };
    }
    case PIN_IS_VALID: {
      const { isValid } = action;
      return { ...state, isValid };
    }
    case RECEIVE_TRACKING_NUMBER: {
      const { trackingNumber } = action;
      return { ...state, trackingNumber };
    }
    case CART_RESET_STATE: {
      return initialState;
    }
    default:
      return state;
  }
}
